const metaTag = document.querySelector('meta[name="keywords"]');
const h1Text = document.querySelector('h1').textContent;
const content = metaTag.getAttribute('content');
const textsToRemove = [
  "openen in modaal",
  "Ga direct naar productinformatie",
  "1",
  "/",
  "van",
  "8"
];

const newContent = content
  .split('\n')
  .filter(line => !textsToRemove.some(text => line.includes(text)))
  .join('\n');

metaTag.setAttribute('content', h1Text);